import React from "react";

const SmallScreenIcon = () => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
      focusable="false"
      aria-hidden="true"
      width="24"
      height="24"
      fill="#333"
      viewBox="0 0 24 24"
      data-testid="BrandingWatermarkOutlinedIcon"
    >
      <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z"></path>
    </svg>
  );
};

export default SmallScreenIcon;
